import Home from './components/Home';
import {Route, Routes} from 'react-router';
import Tutorials from './components/Tutorials';
import Blog from './components/Blog';
import Blog1 from './Blogs/DSA-patterns-every-developer-should-know';
import Blog2 from './Blogs/Why-data-structures-and-algorithms-are-Important-for-interviews';
import Feedback from './components/Feedback';
import AboutUS from './components/AboutUS';
import NotFound from "./components/NotFound"; // ← your 404 component

export default function App() {


  return (
    <Routes>
      <Route exact path="/" element={<Home/>}/>
      <Route exact path="/tutorials"  element={<Tutorials/>}/>
      <Route exact path="/data-structures/:topic" element={<Tutorials/>}/>
      <Route exact path="/blog" element={<Blog/>}/>
      <Route exact path="/DSA-patterns-every-developer-should-know" element={<Blog1/>}/>
      <Route exact path="/Why-data-structures-and-algorithms-are-Important-for-interviews" element={<Blog2/>}/>
      <Route exact path="/feedback" element={<Feedback/>}/>
      <Route exact path="/aboutus" element={<AboutUS/>}/>
      {/* 404 fallback route */}
      <Route path="*" element={<NotFound/>} />
    </Routes>  
  )
}
